import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	troubleshootingGroup: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.troubleshooting-group',
		defaultMessage: 'Troubleshooting and Support',
		description: 'Navigation group heading for troubleshooting and support settings items',
	},
	auditLog: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.audit-log',
		defaultMessage: 'Audit Log',
		description: 'Navigation item which links to a audit log settings page',
	},
	pluginViewer: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.plugin-viewer',
		defaultMessage: 'Plugin Viewer',
		description: 'Navigation item which links to a plugin viewer page',
	},
	modulesViewer: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.modules-viewer',
		defaultMessage: 'Modules Viewer',
		description: 'Navigation item which links to a modules viewer page',
	},
	systemInfo: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.system-info',
		defaultMessage: 'System info',
		description: 'Navigation item which links to a system info settings page',
	},
	integrityChecker: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.integrity-checker',
		defaultMessage: 'Integrity checker',
		description: 'Navigation item which links to a integrity checker settings page',
	},
	loggingProfiling: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.logging-profiling',
		defaultMessage: 'Logging profiling',
		description: 'Navigation item which links to a logging profiling settings page',
	},
	schedulerDetails: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.scheduler-details',
		defaultMessage: 'Scheduler details',
		description: 'Navigation item which links to a scheduler details settings page',
	},
});
